





import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

@Component({
})
export default class JdhBreakdownCardlessContext extends Vue {
    @ActiveProvide('jds.breakdown.card') breakdownCard = false;
}
